<template>
  <footer class="main-footer">
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block"><b>Version</b> 3.1.0</div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>
